import {FrontRoomApi} from '../api-clients';
import { wrap } from '../wrap';


export const userApi = {
  showTempCustomer: wrap(FrontRoomApi, FrontRoomApi.prototype.showTempCustomer),
  updateTempCustomer: wrap(FrontRoomApi, FrontRoomApi.prototype.updateTempCustomer),
  sendPasswordResetMail: wrap(FrontRoomApi, FrontRoomApi.prototype.sendUserPasswordResetMail),
  sendPasswordReset: wrap(FrontRoomApi, FrontRoomApi.prototype.sendUserPasswordReset),
};